import { getSolanaRecentBlockhash } from './brc20-api';
import { PublicKey, SystemProgram, Transaction, LAMPORTS_PER_SOL, Connection } from '@solana/web3.js';
import { toast } from 'react-toastify';
import Solflare from '@solflare-wallet/sdk';
import { useTranslation } from 'react-i18next';



export const payWithPhantomWallet = async (address, amount, message) => {
  try {
    if (!window.solana?.isPhantom) {
      toast.error(message);
      return;
    }
  
    const provider = window.phantom.solana;
    const { publicKey } = await provider.connect();
  
    const transaction = new Transaction().add(
      SystemProgram.transfer({
        fromPubkey: publicKey,
        toPubkey: new PublicKey(address), 
        lamports: LAMPORTS_PER_SOL * amount, // 0.1 SOL (in lamports)
      })
    );
  
    transaction.feePayer = publicKey;
    let recentBlockHash = await getSolanaRecentBlockhash();
  
    transaction.recentBlockhash = recentBlockHash.blockhash;
  
    const { signature } = await provider.signAndSendTransaction(transaction);
    return true;
  }
  catch(e) {
    console.log(e);
    return false;
  }
}

export const payWithSolflareWallet = async (solflareWallet, publicKey,address, amount, message) => {
  try {
    if (!window.solflare?.isSolflare) {
      toast.error(message);
      return;
    }
    
    // await solflareWallet.connect();
    const transaction = new Transaction().add(
      SystemProgram.transfer({
        fromPubkey: publicKey,
        toPubkey: new PublicKey(address), 
        lamports: LAMPORTS_PER_SOL * amount, // 0.1 SOL (in lamports)
      })
    );
  
    transaction.feePayer = publicKey;
    let recentBlockHash = await getSolanaRecentBlockhash();
  
    transaction.recentBlockhash = recentBlockHash.blockhash;
  
    const { signature } = await solflareWallet.signAndSendTransaction(transaction);
    return true;
  }
  catch(e) {
    console.log(e);
    return false;
  }
}

export const payWithMagicEdenWallet = async (wallet, publicKey,address, amount, message) => {
  try {
    if (!window.magicEden?.solana) {
      toast.error(message);
      return;
    }
    
    // await solflareWallet.connect();
    const transaction = new Transaction().add(
      SystemProgram.transfer({
        fromPubkey: publicKey,
        toPubkey: new PublicKey(address), 
        lamports: LAMPORTS_PER_SOL * amount, // 0.1 SOL (in lamports)
      })
    );
  
    transaction.feePayer = publicKey;
    let recentBlockHash = await getSolanaRecentBlockhash();
  
    transaction.recentBlockhash = recentBlockHash.blockhash;
  
    const { signature } = await wallet.signAndSendTransaction(transaction);
    return true;
  }
  catch(e) {
    console.log(e);
    return false;
  }
}